import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Button,
  Card,
  Form,
  Image,
  Row,
  Col,
} from "react-bootstrap";
import Header from "../components/header/Header";
import PhoneInput from "react-phone-input-2";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { checkPayment, mobilePayment } from "../redux/actions/PaymentActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/loader/Loader";
import Swal from "sweetalert2";

function Payment() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const currentStep = "Paiement";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Commande",
    "Paiement",
    "Finalisation",
  ];
  const { totalTTC } = location.state || {};
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const { businessCreationRequest } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);

  const cardSchema = Yup.object({
    cardNumber: Yup.string().required("Le numéro de carte est requis"),
    cvv: Yup.string().required("Le CVV est requis"),
    expiration: Yup.string().required("La date d'expiration est requise"),
  });

  const phoneSchema = Yup.object({
    phoneNumber: Yup.string().required("Le numéro de téléphone est requis"),
  });

  const formik = useFormik({
    initialValues:
      selectedPayment === "visa" || selectedPayment === "mastercard"
        ? {
            cardNumber: "",
            cvv: "",
            expiration: "",
          }
        : {
            phoneNumber: "",
          },
    validationSchema:
      selectedPayment === "visa" || selectedPayment === "mastercard"
        ? cardSchema
        : phoneSchema,
    onSubmit: async (values) => {
      setSubmitting(true);
      if (selectedPayment === "OM" || selectedPayment === "MOMO") {
        await dispatch(
          mobilePayment(
            user.token,
            {
              request: businessCreationRequest.reference,
              phone: values.phoneNumber,
            },
            handleMobilePaymentCallback
          )
        );
      } else {
      }
    },
  });

  const handleMobilePaymentCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        checkPayment(
          user.token,
          data.reference,
          businessCreationRequest.reference,
          handleCheckPaymentCallback
        )
      );
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handleCheckPaymentCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate("/finalization");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handlePaymentSelect = (method) => {
    setSelectedPayment(method);
    formik.resetForm();
  };

  return (
    <Container
      fluid
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        paddingLeft: "15px",
        paddingRight: "15px",
      }}
    >
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />

      <h4 className="mt-4 mb-4">
        Effectuez le <span style={{ color: "#FF5500" }}>paiement</span> pour
        finaliser votre commande
      </h4>

      <Card
        style={{
          maxWidth: "500px",
          margin: "auto",
          padding: "20px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          borderRadius: "18px",
        }}
      >
        <h5 className="mt-1 mb-4">Informations de Paiement</h5>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginBottom: "20px",
          }}
        >
          <Image
            src="/images/payment/orange.png"
            alt="Orange Money"
            onClick={() => handlePaymentSelect("OM")}
            title="Orange Money CM"
            style={{
              width: "80px",
              height: "70px",
              cursor: "pointer",
              padding: 2,
              borderRadius: "8px",
              border:
                selectedPayment === "OM"
                  ? "3px solid #FF5500"
                  : "1px solid #ccc",
            }}
          />
          <Image
            src="/images/payment/mtn.png"
            alt="MTN Mobile Money"
            onClick={() => handlePaymentSelect("MOMO")}
            title="MTN Mobile Money CM"
            style={{
              width: "80px",
              height: "70px",
              cursor: "pointer",
              padding: 2,
              borderRadius: "8px",
              border:
                selectedPayment === "MOMO"
                  ? "3px solid #FF5500"
                  : "1px solid #ccc",
            }}
          />
          <Image
            src="/images/payment/visa.png"
            alt="Visa"
            onClick={() => handlePaymentSelect("visa")}
            title="Visa"
            style={{
              width: "80px",
              height: "70px",
              cursor: "pointer",
              padding: 2,
              borderRadius: "8px",
              border:
                selectedPayment === "visa"
                  ? "3px solid #FF5500"
                  : "1px solid #ccc",
            }}
          />
          <Image
            src="/images/payment/mastercard.jpg"
            alt="MasterCard"
            onClick={() => handlePaymentSelect("mastercard")}
            title="MasterCard"
            style={{
              width: "80px",
              height: "70px",
              cursor: "pointer",
              padding: 2,
              borderRadius: "8px",
              border:
                selectedPayment === "mastercard"
                  ? "3px solid #FF5500"
                  : "1px solid #ccc",
            }}
          />
        </div>

        <Form
          onSubmit={formik.handleSubmit}
          style={{
            maxWidth: "420px",
            margin: "0 auto",
          }}
          className="mt-2"
        >
          {selectedPayment === "visa" || selectedPayment === "mastercard" ? (
            <>
              <Form.Group controlId="cardNumber" className="mb-3">
                <Form.Control
                  type="text"
                  name="cardNumber"
                  placeholder="Numéro de carte"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.cardNumber}
                  isInvalid={
                    formik.touched.cardNumber && formik.errors.cardNumber
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.cardNumber}
                </Form.Control.Feedback>
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="expiration" className="mb-3">
                    <Form.Control
                      type="text"
                      name="expiration"
                      placeholder="MM/AA"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.expiration}
                      isInvalid={
                        formik.touched.expiration && formik.errors.expiration
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.expiration}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="cvv" className="mb-3">
                    <Form.Control
                      type="text"
                      name="cvv"
                      placeholder="CVV"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cvv}
                      isInvalid={formik.touched.cvv && formik.errors.cvv}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.cvv}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="shippingAddress" className="mb-3">
                <Form.Control
                  type="text"
                  name="shippingAddress"
                  placeholder="Adresse de livraison"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.shippingAddress}
                  isInvalid={
                    formik.touched.shippingAddress &&
                    formik.errors.shippingAddress
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.shippingAddress}
                </Form.Control.Feedback>
              </Form.Group>
            </>
          ) : selectedPayment === "OM" || selectedPayment === "MOMO" ? (
            <>
              <Form.Group controlId="phoneNumber" className="mb-3">
                <PhoneInput
                  country={"cm"}
                  value=""
                  placeholder="Numéro de téléphone"
                  onChange={(phone) => {
                    const formattedPhone = phone.startsWith("+")
                      ? phone
                      : `+${phone}`;
                    formik.setFieldValue("phoneNumber", formattedPhone);
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.phoneNumber}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="shippingAddress" className="mb-3">
                <Form.Control
                  type="text"
                  name="shippingAddress"
                  placeholder="Adresse de livraison"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.shippingAddress}
                  isInvalid={
                    formik.touched.shippingAddress &&
                    formik.errors.shippingAddress
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.shippingAddress}
                </Form.Control.Feedback>
              </Form.Group>
            </>
          ) : (
            <p>
              Sélectionnez un moyen de paiement pour afficher le formulaire
              correspondant.
            </p>
          )}

          <Form.Group controlId="termsAccepted" className="mb-4">
            <Form.Check
              type="checkbox"
              label={
                <span>
                  En cochant cette case, vous attestez avoir lu et accepté les{" "}
                  <a
                    href="/conditions-generales"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Conditions Générales
                  </a>{" "}
                  et la{" "}
                  <a
                    href="/charte-vie-privee"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    charte de la vie privée
                  </a>
                  .
                </span>
              }
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            style={{
              width: "80%",
              borderRadius: "10px",
              backgroundColor: "#051259",
              color: "#fff",
              marginTop: 10,
            }}
            disabled={!formik.isValid || !termsAccepted}
          >
            Payer ( {totalTTC} ) <FaArrowRight style={{ marginLeft: "8px" }} />
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

export default Payment;
